/**
 * Used to create `!important` css rules.
 *
 * It amends the returned value with a type assertion
 *  so that TypeScript does not complain about mismatches.
 */
export var important = function important(input) {
  return "".concat(input, " !important");
};